import type { BridgeMessageHandler } from '../message-router.js';
import { cancelInFlightAgentCapabilityWarmup } from '../../agents/capabilities/agent-capability-warmup-run.js';
import { isCliImmediateShutdownRequested } from '../../runtime/cli-process-interrupt.js';

export const handleBridgeIdentified: BridgeMessageHandler<'bridge_identified'> = (msg, deps) => {
  if (typeof msg.bridgeName !== 'string') return;
  deps.onBridgeIdentified({
    bridgeName: msg.bridgeName,
    proxyPorts: msg.proxyPorts,
    previewEnvironments: msg.previewEnvironments,
  });
  setImmediate(() => {
    void (async () => {
      cancelInFlightAgentCapabilityWarmup();
      try {
        await deps.reportAutoDetectedAgents?.();
      } catch (e) {
        deps.log(
          `[Bridge service] Auto-detect agents failed: ${e instanceof Error ? e.message : String(e)}`,
        );
      }
      try {
        await deps.warmupAgentCapabilitiesOnConnect?.();
      } catch (e) {
        deps.log(
          `[Bridge service] Agent capability warmup failed: ${e instanceof Error ? e.message : String(e)}`,
        );
      }
    })();
  });
  setImmediate(() => {
    if (isCliImmediateShutdownRequested()) return;
    try {
      deps.sendLocalSkillsReport?.();
    } catch (e) {
      deps.log(
        `[Bridge service] Local skills report failed: ${e instanceof Error ? e.message : String(e)}`,
      );
    }
  });
};
